export default __webpack_public_path__ + "static/media/imagenes certs_Mesa de trabajo 1.1c2c1d24.png";